module.exports = __webpack_public_path__ + "static/claugiyliamatar-d745fe142dc482b943f047a87300d718.webp";